import React from 'react';
import { numberSanitizer, useHandleInputOnChange } from '../hooks';

const menuValues = [100, 55, 35, 25, 15];

const ChooseAmount = ({ onChange, value }) => {
  const handleChange = useHandleInputOnChange(onChange, numberSanitizer);

  return (
    <div className="form__group form__group--amount">
      <fieldset className="choose-amount">
        <legend className="form__label">Wybierz kwotę</legend>
        <div className="choose-amount__items">
          {menuValues.map((amount) => (
            <div className="form-group__fieldset__element choose-amount__items__item" key={amount}>
              <input
                type="radio"
                value={amount}
                name="amount"
                onChange={handleChange}
                checked={value === amount}
                id={`amount-${amount}`}
              />
              <label htmlFor={`amount-${amount}`}>
                <div>
                  <span>{amount}</span>
                  <span>zł</span>
                </div>
              </label>
            </div>
          ))}
          <div className="form-group__fieldset__element choose-amount__items__item choose-amount__items__item--custom">
            <input
              type="radio"
              value={5}
              name="amount"
              onChange={handleChange}
              id="amount-0"
              checked={menuValues.includes(value) === false}
            />
            <label htmlFor="amount-0">
              <div>
                <span>inna</span>
                <span>kwota</span>
              </div>
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default ChooseAmount;
